import React, { useState } from 'react';

// mui
import { Container, Box } from '@mui/system';
import { Typography } from '@mui/material';

// block groups
import BaseTable from '../../../../../blockGroups/table/BaseTable/BaseTable.blockgroup';

// utils
import { cleanCrewMemberAssignments } from './CrewDetailAssignments.collection.utils';
import { dateComparator } from '../../../../../shared/sorting/dates';

const crewDetailColumnConfigs = [
    { 
        name: "job", 
        title: "Job", 
        objectFieldsToDisplay: ["job"],
        objectFieldsDelimeter: "",
        useNestedObject: false 
    },
    { 
        name: "date", 
        title: "Date", 
        objectFieldsToDisplay: ["date"],
        objectFieldsDelimeter: "", 
        useNestedObject: false,
        type: 'date',
        sortComparator: dateComparator
    },
    { 
        name: "position", 
        title: "Position", 
        objectFieldsToDisplay: ["position"],
        objectFieldsDelimeter: "", 
        useNestedObject: false 
    },
    { 
        name: "time", 
        title: "Time", 
        objectFieldsToDisplay: ["time"],
        objectFieldsDelimeter: "", 
        useNestedObject: false 
    },
    { 
        name: "hours", 
        title: "Hours", 
        objectFieldsToDisplay: ["hours"],
        objectFieldsDelimeter: "", 
        useNestedObject: false,
        type: 'number',
        align: 'left',
        headerAlign: 'left'
    },
    { 
        name: "overTime", 
        title: "OT", 
        objectFieldsToDisplay: ["overTime"],
        objectFieldsDelimeter: "", 
        useNestedObject: false,
        type: 'number',
        align: 'left',
        headerAlign: 'left'
    },
    { 
        name: "doubleTime", 
        title: "DT", 
        objectFieldsToDisplay: ["doubleTime"],
        objectFieldsDelimeter: "", 
        useNestedObject: false,
        type: 'number',
        align: 'left',
        headerAlign: 'left'
    },
];

const CrewDetailAssignments = ({ data = { crewMember: { assignments: [], isForeman: false }}, loading, error }) => {
    const [sortModel, setSortModel] = useState([{ field: "date", sort: "desc" }])

    const cleanedData = cleanCrewMemberAssignments(data.crewMember.assignments, data.crewMember.isForeman)


    return (<Container maxWidth={false} disableGutters sx={{ marginTop: 8, marginBottom: 8}}>
        <Typography variant='h4'>Assignments</Typography>
        <Box sx={{ height: 500, width: "100%", marginTop: 2}}>
            <BaseTable
                rawData={cleanedData}
                columnConfigs={crewDetailColumnConfigs}
                loading={loading}
                sortModel={sortModel}
                onSortModelChange={(newSortModel) => setSortModel(newSortModel)}
            />
        </Box>
    </Container>
    );
}

export default CrewDetailAssignments;